import React, { FC } from 'react';
import cx from 'classnames';
import {
  Logo,
  ButtonClose,
  Section,
  Link,
} from 'components';
import { routes } from 'appConstants';
import { history } from 'utils';

import mospromLogo from 'assets/img/header-v4/mosprom.svg';
import styles from './styles.module.scss';

type Props = {
  onBanner?: boolean,
};

const HeaderLogin: FC<Props> = ({ onBanner = false }) => (
  <header className={cx(styles.header, onBanner && styles.headerOnBanner)}>
    <Section tag="div" className={styles.section}>
      <Link to={routes.main.root}>
        {onBanner ? (
          <img src={mospromLogo} alt="МОСПРОМ" className={styles.logoV4} />
        ) : (
          <Logo className={styles.logo} view="dark" />
        )}
      </Link>

      <ButtonClose
        theme="transparent"
        className={onBanner ? styles.closeLight : undefined}
        onClick={() => history.push(routes.main.root)}
      />
    </Section>
  </header>
);

export default HeaderLogin;
